const SFApi = window.SFApi
const isInClient = SFApi ? SFApi.isInClient() : false
export function deviceInfo() {
  // 获取设备信息
  return isInClient ? SFApi.device.deviceInfo()?.deviceId ?? '' : ''
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
/**
 * 字符串脱敏
 * @param {*} str 字符串
 * @param {*} beginLen 符串前面保留位数
 * @param {*} endLen 字符串后面保留位数
 * @returns string
 */
export function desensitization(str, beginLen, endLen) {
  beginLen = beginLen ? beginLen : 1
  endLen = endLen ? endLen : 1
  var len = str.length - beginLen - endLen
  var xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, beginLen) + xing + str.substring(str.length - endLen)
}
